<template>
  <div class="indexPage">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="排行榜" name="first">
          <span
            class="childTabs"
            @click="rankTypeClick('operation')"
            :class="{activeLink: activeLink=='operation'}"
          >操作排行</span>
          <span
            class="childTabs"
            @click="rankTypeClick('login')"
            :class="{activeLink: activeLink=='login'}"
          >登录排行</span>
          <!-- <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small"
                  class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="contentBox">
      <div class="rightContent">
        <div class="everyoneBox" v-for="(item, index) in topListDate" :key="index">
          <div class="everyoneHead">
            <span v-if="index == 'last'">最近</span>
            <span v-else-if="index == 'today'">今天</span>
            <span v-else-if="index == 'lastWeek'">本周</span>
            <span v-else>本月</span>
            <span>
              <span class="topNum">
                TOP
                {{topListNum}}
              </span>
            </span>
          </div>
          <div class="everyoneCon">
            <div v-if="index == 'last'">
              <div v-if="activeLink=='operation'">
                <div class="contentTitle">
                  <div class="nameBox">
                    <span class="order"></span>
                    <span class="titleName">员工</span>
                  </div>
                  <span class="operation">操作</span>
                </div>
                <div class="contentList" v-for="(list, index) in item" :key="index">
                  <div class="nameBox">
                    <span class="order">{{index+1}}、</span>
                    <span
                      class="name"
                      v-if="list.user"
                      :title="list.user.name.length>11?list.user.name:''"
                    >{{list.user.name}} ({{list.user.employeeNum}})</span>
                  </div>
                  <span
                    v-if="list.action && list.action.length < 8"
                    class="operation allowSkip"
                    @click="$systemLogDetail(list)"
                  >{{list.action}}</span>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="list.action"
                    placement="top"
                    :open-delay="300"
                  >
                    <span
                      class="operation textOverflow allowSkip"
                      @click="$systemLogDetail(list)"
                    >{{list.action}}</span>
                  </el-tooltip>
                </div>
              </div>
              <div v-else-if="activeLink=='login'">
                <div class="contentTitle">
                  <div class="nameBox">
                    <span class="order"></span>
                    <span class="titleName">员工</span>
                  </div>
                  <span class="address">IP</span>
                </div>
                <div class="contentList" v-for="(list, index) in item" :key="index">
                  <div class="nameBox">
                    <span class="order">{{index+1}}、</span>
                    <span v-if="list.user" class="name">{{list.user.name}} ({{list.user.employeeNum}})</span>
                    <span v-else>-</span>
                  </div>
                  <span class="address">{{list.ip}}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="contentTitle">
                <div class="nameBox">
                  <span class="order"></span>
                  <span class="titleName">员工</span>
                </div>
                <span class="count">次数</span>
              </div>
              <div class="contentList" v-for="(list, index) in item" :key="index">
                <div class="nameBox">
                  <span class="order">{{index+1}}、</span>
                  <span v-if="list.user" class="name">{{list.user.name}} ({{list.user.employeeNum}})</span>
                  <span v-else>-</span>
                </div>
                <span class="count">{{list.count}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiTopListAction, apiTopListLogin } from "@/api/rankingApi.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/indexPage", subTabs: { activeLink: ["operation", "login"] } },
  data() {
    return {
      activeLink: "operation",
      isMoreSearch: false,
      topListDate: {},
      topListNum: 20
    };
  },
  methods: {
    rankTypeClick(rankName) {
      this.activeLink = rankName;
      this.getTopListDate();
    },
    async getTopListDate() {
      let res;
      this.topListDate = {};
      if (this.activeLink == "operation") {
        res = await apiTopListAction({
          top: this.topListNum
        });
      } else if (this.activeLink == "login") {
        res = await apiTopListLogin({
          top: this.topListNum
        });
      }
      // console.log(res)
      if (res.code == 0) {
        this.topListDate = res.data;
      }
    }
  },
  created() {
    this.getTopListDate();
  }
};
</script>

<style lang="less" scoped>
.indexPage {
  .contentBox {
    .rightContent {
      flex-direction: row;
      background-color: var(--themePageBg);
      .everyoneBox {
        flex: 0 0 315px;
        margin-right: 10px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        background-color: #fdfdfd;
        &:last-child {
          margin-right: 0;
        }
        .everyoneHead {
          height: 50px;
          line-height: 50px;
          margin: 0 10px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ccc;
          .topNum {
            color: #8a8a8a;
          }
        }
        .everyoneCon {
          overflow: auto;
          .contentTitle,
          .contentList {
            display: flex;
            justify-content: space-around;
            margin: 10px 0;
            padding: 0 10px;
            .nameBox {
              width: 180px;
              display: flex;
              .order {
                width: 30px;
              }
              .titleName {
                margin-left: 35px;
              }
              .name {
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .address {
              width: 110px;
              text-align: center;
            }
            .count {
              width: 60px;
              text-align: center;
            }
            .operation {
              width: 110px;
              text-align: center;
            }
            .returnCode {
              width: 80px;
              text-align: center;
            }
          }
          .contentList {
            color: #8a8a8a;
          }
        }
      }
    }
  }
}
</style>